'use strict';

/**
 * @ngdoc function
 * @name 360StoreAngularApp.controller:ModalUpgradeFormCtrl
 * @description
 * # ModalUpgradeFormCtrl
 * Controller of the 360StoreAngularApp
 */
angular.module('360StoreAngularApp')
	.controller('ModalUpgradeFormCtrl', function ($scope, $location, api, /*string*/ session,/**ProductLine*/ product) {
		/**
		 * @type {UpgradeCandidates}
		 */
		$scope.upgradeCandidates = {};

		$scope.product = product;

		$scope.upgradeParams = {
			licenseKey: localStorage.getItem('licenseKey') || '',
			registeredTo: localStorage.getItem('registeredTo') || '',
		};

		$scope.tmp = {
			rememberMe:true,
			step: 'gatherOldLicenseKey',
		};

		$scope.lookupLicenseUpgradingFrom = async () => {
			$scope.upgradeCandidates = await api.getUpgradeCandidates($scope.upgradeParams.licenseKey, $scope.upgradeParams.registeredTo, product.id, $scope.tmp.rememberMe);
			$scope.tmp.step = 'chooseUpgrade';
		};

		$scope.choose = function (variant) {
			if ($scope.modalForm.$invalid) {
				$scope.modalForm.$setSubmitted();
				toastr.warning('Please fix form validation first');
				return;
			}
			api.createCartAction({action: 'Upgrade', variantId: variant.id, license: $scope.upgradeParams})
				.then(function (action) {
					session.addCartAction(action);
					$scope.$close(variant);
				});
		};

		/*
		///////////////////////////////////////////////////////////////////////////
		// INIT
		///////////////////////////////////////////////////////////////////////////
		*/
		if ($scope.upgradeParams.registeredTo && $scope.upgradeParams.licenseKey && $location.search().licenseKey) { // only auto-lookup if the licenseKey is in the actual URL
			$scope.lookupLicenseUpgradingFrom().then();
		}
	});
